







export default {
  name: 'AppTitle.vue',
};
